import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import {
  addButtonPadding,
  registerPatientButtonStyles,
} from "../../common/commonStyles";
import ReusableSnackbar from "../../shared/Alert/ReusableSnackbar";
import validators from "../../utils/validations/validators";
import api from "../../services/api";
import EmailIcon from "@mui/icons-material/Email";
import "../SettingsManagement/SettingManagement.css";
import DeleteIcon from "@mui/icons-material/Delete";

export default function SettingManagement({ userDetail }) {
  const [passwordData, setPasswordData] = useState({
    new_password: "",
    email: userDetail?.email,
    confirm_password: "",
  });
  const [mailData, setMailData] = useState({
    email_type: "",
    email_host: "",
    email_port: "",
    email: "",
    email_password: "",
  });
  const [mailDetails, setMailDetails] = useState();
  const [snackbarOpen, setSnackbarOpen] = useState({
    status: false,
    message: "",
    severity: "",
  });
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    getMailconfigDeatils();
  }, []);

  const getMailconfigDeatils = async () => {
    try {
      let response = await api.get("app/messaging/mail");
      setMailDetails(response?.data);
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };
  const handleSnackClose = () => setSnackbarOpen(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (validators[name]) {
      const errorMsg = validators[name](value);
      setValidationErrors((prev) => ({
        ...prev,
        [name]: errorMsg,
      }));
    }
  };

  const handleMailInputChange = (e) => {
    const { name, value } = e.target;
    setMailData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (validators[name]) {
      const errorMsg = validators[name](value);
      setValidationErrors((prev) => ({
        ...prev,
        [name]: errorMsg,
      }));
    }
  };

  const handleResetPassword = async () => {
    // Implement password reset logic here
    if (passwordData.new_password !== passwordData.confirm_password) {
      setSnackbarOpen({
        status: true,
        message: "Passwords do not match!",
        severity: "error",
      });
      return;
    }
    // Simulate successful password reset
    try {
      const payload = {
        email: userDetail?.email,
        new_password: passwordData.new_password,
      };
      const response = await api.post(`app/reset-password-by-email`, payload);

      if (response.status === 200) {
        setPasswordData({
          new_password: "",
          confirm_password: "",
        });
        setSnackbarOpen({
          status: true,
          message: "Password has been reset successfully!",
          severity: "success",
        });
      }
    } catch (error) {
      setSnackbarOpen({
        status: true,
        message:
          error?.response?.data?.detail[0].msg ||
          "Something went wrong ! Please try again",
        severity: "error",
      });
    }
  };
  const handleConfigureMail = async () => {
    try {
      const response = await api.post(`app/messaging/mail`, mailData);
      if (response.status === 201) {
        setMailData({
          email_type: "",
          email_host: "",
          email_port: "",
          email: "",
          email_password: "",
        });
        setSnackbarOpen({
          status: true,
          message: "Mail configuration added!",
          severity: "success",
        });
        await getMailconfigDeatils();
      }
    } catch (error) {
      setSnackbarOpen({
        status: true,
        message: "Something went wrong ! Please try again",
        severity: "error",
      });
    }
  };
  const handleDelete =  async(id)=>{
    try {
      const response = await api.delete(`app/messaging/${id}`);
      if (response.status === 200) {
        setSnackbarOpen({
          status: true,
          message: "Mail deleted successfully !",
          severity: "success",
        });
        await getMailconfigDeatils();
      }
    } catch (error) {
      setSnackbarOpen({
        status: true,
        message: "Something went wrong ! Please try again",
        severity: "error",
      });
    }
  }
  const isFormValid =
    Object.values(validationErrors).every((err) => err === "") &&
    Object.values(passwordData).every((val) => val !== "" && val !== null);
  const isconfigMailValid =
    Object.values(validationErrors).every((err) => err === "") &&
    Object.values(mailData).every((val) => val !== "" && val !== null);

  return (
    <>
      <Box className="setting_section">
        <h4>Reset Your Password</h4>
        <p>
          Time to set a new password 😊 Enter and confirm your new password
          below. Keep it strong and secure!
        </p>
        <Grid container spacing={2}>
          <Grid size={5}>
            <TextField
              required
              fullWidth
              margin="normal"
              label="New Password"
              name="new_password"
              size="small"
              value={passwordData?.new_password}
              onChange={handleInputChange}
              autoComplete="off"
              className="custom-textfield"
              error={!!validationErrors.new_password}
              helperText={validationErrors.new_password}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
          <Grid size={5}>
            <TextField
              required
              fullWidth
              margin="normal"
              label="Confirm Password"
              name="confirm_password"
              size="small"
              value={passwordData?.confirm_password}
              onChange={handleInputChange}
              autoComplete="off"
              className="custom-textfield"
              error={!!validationErrors.confirm_password}
              helperText={validationErrors.confirm_password}
            />
          </Grid>
        </Grid>
        <Button
          variant="contained"
          sx={[registerPatientButtonStyles, addButtonPadding]}
          size="small"
          onClick={() => {
            handleResetPassword();
          }}
          disabled={!isFormValid}
        >
          Change Password
        </Button>
        <ReusableSnackbar
          open={snackbarOpen.status}
          message={snackbarOpen.message}
          onClose={handleSnackClose}
          severity={snackbarOpen.severity}
        />
      </Box>
      <Box className="setting_section">
        <h4>Mail Configuration</h4>
        <p>
          Add a mail configuration for your communication.
        </p>
        <Grid container spacing={2} className="align-items-center">
          <Grid size={2}>
            <TextField
              required
              fullWidth
              margin="normal"
              label="Email Type"
              name="email_type"
              size="small"
              value={mailData?.email_type}
              onChange={handleMailInputChange}
              autoComplete="off"
              className="custom-textfield"
              error={!!validationErrors.email_type}
              helperText={validationErrors.email_type}
            />
          </Grid>
          <Grid size={2}>
            <TextField
              required
              fullWidth
              margin="normal"
              label="Host"
              name="email_host"
              size="small"
              value={mailData?.email_host}
              onChange={handleMailInputChange}
              autoComplete="off"
              className="custom-textfield"
              error={!!validationErrors.email_host}
              helperText={validationErrors.email_host}
            />
          </Grid>
          <Grid size={1}>
            <TextField
              required
              fullWidth
              margin="normal"
              label="Port"
              name="email_port"
              size="small"
              value={mailData?.email_port}
              onChange={handleMailInputChange}
              autoComplete="off"
              className="custom-textfield"
              error={!!validationErrors.email_port}
              helperText={validationErrors.email_port}
            />
          </Grid>
          <Grid size={2}>
            <TextField
              required
              fullWidth
              margin="normal"
              label="Email"
              name="email"
              size="small"
              value={mailData?.email}
              onChange={handleMailInputChange}
              autoComplete="off"
              className="custom-textfield"
              error={!!validationErrors.email}
              helperText={validationErrors.email}
            />
          </Grid>
          <Grid size={2}>
            <TextField
              required
              fullWidth
              margin="normal"
              label="Email Password"
              name="email_password"
              size="small"
              value={mailData?.email_password}
              onChange={handleMailInputChange}
              autoComplete="off"
              className="custom-textfield"
              error={!!validationErrors.email_password}
              helperText={validationErrors.email_password}
            />
          </Grid>
          <Grid size={2} sx={{display:'flex',alignItems:'center'}}>
            <Button
              variant="contained"
              sx={[registerPatientButtonStyles, addButtonPadding]}
              size="small"
              onClick={() => {
                handleConfigureMail();
              }}
              disabled={!isconfigMailValid}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={2} className="">
          {mailDetails?.map((item) => (
            <Grid size={4} key={item.id}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 2,
                  padding: 1,
                  marginTop: 2,
                  position: "relative", // Add this
                  "&:hover .deleteBtn": {
                    opacity: 1, // Show delete on hover
                  },
                }}
              >
                <IconButton
                  className="deleteBtn"
                  onClick={() => handleDelete(item.id)}
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    opacity: 0,
                    transition: "0.3s",
                    color: "red",
                  }}
                >
                  <DeleteIcon sx={{ fontSize: "17px" }} />
                </IconButton>

                <CardContent sx={{ display: "flex", gap: 2 }}>
                  <Avatar sx={{ width: 48, height: 48, bgcolor: "#4b49ac" }}>
                    <EmailIcon />
                  </Avatar>

                  <Box>
                    <Typography
                      sx={{
                        color: "#4b49ac",
                        fontWeight: 600,
                        fontSize: "16px",
                        textTransform: "capitalize",
                        fontFamily: "Nunito, sans-serif",
                      }}
                    >
                      {item.email_type} Email
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#333",
                        mt: 0.5,
                        fontFamily: "Nunito, sans-serif",
                      }}
                    >
                      {item.email}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "gray",
                        mt: 0.5,
                        fontFamily: "Nunito, sans-serif",
                      }}
                    >
                      Host: {item.email_host}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "gray",
                        fontFamily: "Nunito, sans-serif",
                      }}
                    >
                      Port: {item.email_port}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        <ReusableSnackbar
          open={snackbarOpen.status}
          message={snackbarOpen.message}
          onClose={handleSnackClose}
          severity={snackbarOpen.severity}
        />
      </Box>
    </>
  );
}
